import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	contributionsStreamHeader: {
		id: 'polaris-common.plays.play-stream.contributions-stream-header',
		defaultMessage: 'Other votes',
		description: 'Header for a list of votes contributions from other users',
	},
});
